<div *ngIf="isWaitingClassSchedule" class="text-right grid-button">
  <button
    class="px-8 mr-2 mat-primary"
    mat-flat-button
    [color]="'accent'"
    *ngIf="waitButtonToggle"
    type="button"
    (click)="showWaitlistProgramConfirmation()"
  >
    Show Waitlisted Programs
  </button>
  <button
    class="px-8 mr-2 mat-primary"
    mat-flat-button
    [color]="'accent'"
    *ngIf="!waitButtonToggle"
    type="button"
    (click)="filterWaitingListProgram()"
  >
    Hide Waitlisted Programs
  </button>
</div>
<div class="flex flex-col gt-sm:flex-row desktop-table">
  <div class="flex flex-col">
    <div class="mt-5">
      <ngx-datatable
        class="material"
        [rows]="rows"
        [columnMode]="'force'"
        [headerHeight]="50"
        [footerHeight]="50"
        rowHeight="auto"
        [selected]="selected"
        [selectionType]="'checkbox'"
        (select)="onSelect($event)"
      >
        <ngx-datatable-column [checkboxable]="!feeByProgram" [width]="50">
        </ngx-datatable-column>

        <ngx-datatable-column name="Name" [sortable]="false" width="100">
          <ng-template
            let-row="row"
            let-value="value"
            ngx-datatable-cell-template
          >
            {{ row.Name }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column
          name="Status"
          [sortable]="false"
          prop="Is_Active__c"
          width="100"
        >
          <ng-template
            let-row="row"
            let-value="value"
            ngx-datatable-cell-template
          >
            <span *ngIf="value === false">Unavailable</span>
            <span
              *ngIf="
                value === true && row.Available_Spaces__c > row.Booked_Count__c
              "
              >Available</span
            >
            <span
              matTooltip="This Program Has A Waitlist."
              *ngIf="isClassOnWaitingList(value, row)"
            >
              Waitlist
            </span>
            <span
              matTooltip="This Class Has Been Fully Booked"
              *ngIf="isClassFullyBooked(row)"
              >Fully Booked</span
            >
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column
          name="Fee"
          [sortable]="false"
          width="100"
          class="tester"
          *ngIf="!feeByProgram"
        >
          <ng-template
            let-row="row"
            let-value="value"
            ngx-datatable-cell-template
          >
            <span *ngIf="!isKidSubsidize">{{
              row.Program_Fee__c | currency : "CAD"
            }}</span>
            <span *ngIf="isKidSubsidize">
              {{ row.Subsidized_Rate__c | currency : "CAD" }}</span
            >
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Open Spot" [sortable]="false" width="100">
          <ng-template
            let-row="row"
            let-value="value"
            ngx-datatable-cell-template
          >
            {{ row.Available_Spaces__c - row.Booked_Count__c }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column
          name="Date"
          prop="Date__c"
          [sortable]="false"
          width="100"
        >
        </ngx-datatable-column>

        <ngx-datatable-column
          name="Day"
          prop="Program_day__c"
          [sortable]="false"
          width="100"
        >
        </ngx-datatable-column>
        <ngx-datatable-column name="Start Time" [sortable]="false" width="100">
          <ng-template
            let-row="row"
            let-value="value"
            ngx-datatable-cell-template
          >
            {{ row.startTime }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="End Time" [sortable]="false" width="100">
          <ng-template
            let-row="row"
            let-value="value"
            ngx-datatable-cell-template
          >
            {{ row.endTime }}
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>
  </div>
</div>
